import { SignUpInterface } from '@/modules/backend';
import RestService from '@/modules/backend/RestService';
import { UserLoginData } from '@/modules/backend/Dto/UserLoginData';
import { plainToClass } from 'class-transformer';
import { User } from '@/modules/backend/Entities/User';
import { CreateUserData } from '@/modules/backend/Dto/CreateUserData';
import { EditUserData } from '@/modules/backend/Dto/EditUserData';

export default class Users {
  private readonly rest: RestService;

  public constructor(rest: RestService) {
    this.rest = rest;
  }

  /**
   * @deprecated
   * @constructor
   * @param _payload
   */
  public async SignUp(_payload: SignUpInterface): Promise<string> {
    throw new Error('Method not implemented.');
  }

  public async LogIn(payload: UserLoginData): Promise<string> {
    const result = await this.rest.post<string>('/api/v1/user/login', payload);

    window.localStorage.setItem('AuthToken', JSON.stringify({
      token: result
    }));

    await this.rest.EmitLogin();

    return result;
  }

  public async LogOut(): Promise<boolean> {
    window.localStorage.removeItem('AuthToken');
    try {
      await this.rest.EmitLogout();
      return true;
    } catch (e) {
      return false;
    }
  }

  public async Info(): Promise<User> {
    const plainUser = await this.rest.get('/api/v1/user/info');
    return plainToClass(User, plainUser);
  }

  public async Fetch(): Promise<User[]> {
    const users = await this.rest.get<User[]>('/api/v1/users');
    return plainToClass(User, users);
  }

  public async Create(payload: CreateUserData): Promise<User> {
    const user: User = await this.rest.post<User>('/api/v1/user', payload);
    return plainToClass(User, user);
  }

  public async Edit(payload: EditUserData): Promise<User> {
    const user: User = await this.rest.put('/api/v1/user', payload);
    return plainToClass(User, user);
  }

  public async Remove(user: User): Promise<void> {
    await this.rest.delete(`/api/v1/user/${user.getId()}`);
  }
}
